import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';

interface ParishDetails {
    details: any;
    loading: boolean;
    error: string | null | boolean;
}
const initialState: ParishDetails = {
    details: {},
    loading: false,
    error: null,
};
interface FetchParishDetailsPayload {
    companyId: string;
}

export const fetchParishDetails = createAsyncThunkWrapper<any, FetchParishDetailsPayload>(
    'parishDetails/fetchParishDetails',
    async ({ companyId }: FetchParishDetailsPayload) => {
        const response: any = await client.get('/merchant/getCompany', {
            headers: {
                companyId,
            },
        });
        return response?.store || {};
    }
);

const parishDetailsSlice = createSlice({
    name: 'parishDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchParishDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchParishDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.details = action.payload || {};
        });
        builder.addCase(fetchParishDetails.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    },
});

export default parishDetailsSlice.reducer;
